import { defineNuxtPlugin } from '#app'
import { PushNotifications } from '@capacitor/push-notifications'

import { Device } from '@capacitor/device';
import { Capacitor } from '@capacitor/core';


export default defineNuxtPlugin(() => {
  let device_id: string|null = null

  const registerDevice = () => {
    ws.send('device.register',{
      device_id,
      visitor_id: visitorId(),
      firebase_registration_token: useState('firebase_token').value,
      user_agent: navigator.userAgent,
      platform: Capacitor.getPlatform(),
    })

    // watch once until isAuthed is true
    const stop = watch(isAuthed, (newVal) => {
      if (newVal) {
        ws.send('device.register',{
          device_id,
          visitor_id: visitorId(),
          firebase_registration_token: useState('firebase_token').value,
          user_agent: navigator.userAgent,
          platform: Capacitor.getPlatform(),
        })
        stop()
      }
    })

  }

  const addListeners = async () => {
    await PushNotifications.addListener('registration', token => {
      console.info('[capfb] Registration token: ', token.value)
      useState('firebase_token').value = token.value


      Device.getId().then((info) => {
        console.log('[app.v] Device Info:', info.identifier)
        device_id = info.identifier

      }).catch((e) => {
        console.log('[app.v] Device Info error:', e)
      }).finally(() => {
        registerDevice()
      })
    })
    await PushNotifications.addListener('registrationError', err => {
      console.error('[capfb] Registration error: ', err.error)
    })
    await PushNotifications.addListener('pushNotificationReceived', notification => {
      console.log('[capfb] Push notification received: ', notification)
    })
    await PushNotifications.addListener('pushNotificationActionPerformed', notification => {
      console.log('[capfb] Push notification action performed', notification.actionId, notification.inputValue)
    })
    await PushNotifications.addListener('pushNotificationActionPerformed', action => {
      console.log('[capfb] Action performed: ', action)
    })
  }

  const registerNotifications = async () => {
    let permStatus = await PushNotifications.checkPermissions()
    if (permStatus.receive === 'prompt') {
      permStatus = await PushNotifications.requestPermissions()
    }
    if (permStatus.receive !== 'granted') {
      throw new Error('[capfb] User denied permissions!')
    }
    await PushNotifications.register()
  }


  if(!Capacitor.isNativePlatform()){
    registerDevice()
  }else
    // Initialize on client-side
    if (typeof window !== 'undefined') {
      addListeners()
      registerNotifications()
    }
})
